import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=21d46ce4&"
import script from "./UserPreferences.vue?vue&type=script&lang=ts&"
export * from "./UserPreferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports